export default "__VITE_ASSET__BkP58ITp__"